<template>
  <div class="p-4 mt-4">
    <div class="row" v-if="dashboard_data">
      <div class="col-12 col-sm-6 col-md-2" >
        <div class="card p-3 text-white shadow">
          <div class="d-flex justify-content-between">
            <div>
              <p
                class="text-dark m-0"
                style="font-size: 13px; font-weight: 600"
              >
                Total
              </p>
              <h6>
                {{dashboard_data?.total?.total ?? 0}}
              </h6>
            </div>

            <div>
              <span
                class="p-2 rounded"
                :style="{ backgroundColor: `rgba(128, 0, 128, 0.1)` }"
              >
                <i
                  class=" fa fa-x fa fa-users"
                  :style="{ color: 'purple' }"
                ></i>
              </span>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 col-sm-6 col-md-2" >
        <div class="card p-3 text-white shadow">
          <div class="d-flex justify-content-between">
            <div>
              <p
                class="text-dark m-0"
                style="font-size: 13px; font-weight: 600"
              >
                Generator Up
              </p>
              <h6>
                {{dashboard_data?.gen?.up_count ?? 0}}
              </h6>
            </div>

            <div>
              <span
                class="p-2 rounded"
                :style="{ backgroundColor: `rgba(255, 0, 0, 0.1)` }"
              >
                <i
                  class="fa fa-x fa-lightbulb"
                  :style="{ color: 'white' }"
                ></i>
              </span>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 col-sm-6 col-md-2" >
        <div class="card p-3 text-white shadow">
          <div class="d-flex justify-content-between">
            <div>
              <p
                class="text-dark m-0"
                style="font-size: 13px; font-weight: 600"
              >
                Generator Down
              </p>
              <h6>
                {{dashboard_data?.gen?.down_count ?? 0}}
              </h6>
            </div>

            <div>
              <span
                class="p-2 rounded"
                :style="{ backgroundColor: `rgba(255, 0, 0, 0.1)` }"
              >
                <i
                  class=" fa fa-x fa-lightbulb"
                  :style="{ color: 'red' }"
                ></i>
              </span>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 col-sm-6 col-md-2" >
        <div class="card p-3 text-white shadow">
          <div class="d-flex justify-content-between">
            <div>
              <p
                class="text-dark m-0"
                style="font-size: 13px; font-weight: 600"
              >
                Electric Up
              </p>
              <h6>
                {{dashboard_data?.elc?.up_count ?? 0}}
              </h6>
            </div>

            <div>
              <span
                class="p-2 rounded"
                :style="{ backgroundColor: `rgba(255, 0, 0, 0.1)` }"
              >
                <i
                  class=" fa fa-x fa-lightbulb"
                  :style="{ color: 'white' }"
                ></i>
              </span>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 col-sm-6 col-md-2" >
        <div class="card p-3 text-white shadow">
          <div class="d-flex justify-content-between">
            <div>
              <p
                class="text-dark m-0"
                style="font-size: 13px; font-weight: 600"
              >
                Electric Down
              </p>
              <h6>
                {{dashboard_data?.elc?.down_count ?? 0}}
              </h6>
            </div>

            <div>
              <span
                class="p-2 rounded"
                :style="{ backgroundColor: `rgba(255, 0, 0, 0.1)` }"
              >
                <i
                  class=" fa fa-x fa-lightbulb"
                  :style="{ color: 'red' }"
                ></i>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="mt-5">
      <div class="row" style="row-gap: 10px !important">
        <div
          v-for="(data, index) in ip_data" :key="index"
          class="col-12 col-sm-6 col-md-3 col-lg-2" 
        >
          <div class="card p-3 text-white position-relative shadow" :style="data.down_type == 'dw' ? 'background :rgb(171 29 29) !important'  : ''">
            <div class="d-flex justify-content-between">
              <div
                class="d-flex justify-content-center align-items-center"
                style="width: 40px; height: 40px; border-radius: 50%"
                :style="{ backgroundColor: 'rgba(0, 128, 0, 0.1)' }"
              >
                <i v-if="data.down_type == 'up'"
                  class="fa fa-check"
                  :style="{ color: 'green', opacity: '1' }"
                ></i>
                <i v-else
                  class="fa fa-times"
                  :style="{ color: 'red', opacity: '1' }"
                ></i>
              </div>

              <!-- Three Dots Menu -->
              <div class="custom-dropdown">
                <i
                  class="fa fa-ellipsis-h"
                  style="cursor: pointer; color: gray; font-size: 10px"
                ></i>
                <div class="dropdown-content">
                  <a href="#" style="font-size: 12px" @click="deleteItem(data.id)">Delete</a>
                  <a href="#" style="font-size: 12px">Update</a>
                </div>
              </div>
            </div>

            <!-- content -->
           <div class="d-flex justify-content-between align-items-center pl-4" style="height:120px !important">
  <div>
    
      <h5 class="text-muted fw-bold m-0">{{ data.downtime_duration }}</h5>
    <div class="d-flex gap-2 align-items-center">
      <p class=" m-0">{{ data.type.charAt(0).toUpperCase() + data.type.slice(1) }}</p>
      <p class="m-0">{{ data.pop_name }}</p>
    </div>
    <div class="mt-1">
      <p class="text-muted small m-0">Alive Time: {{ data.pop_alive_time ?? '00' }} min</p>
    </div>
  </div>
</div>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { useElcMonitorApi } from '@/services/elc-monitor.service';

export default {
  data() {
    return {

      analyticsCards: [
        {
          title: "Revenue",
          value: "$95.2k",
          change: "+12%",
          changeColor: "text-success",
          description: "Revenue Increase",
          icon: "fa fa-check",
          iconColor: "green",
          bgColor: "rgba(0, 128, 0, 0.1)",
        },
        {
          title: "Logistics",
          value: "44.10k",
          change: "+12%",
          changeColor: "text-success",
          description: "Revenue Increase",
          icon: "fa fa-times",
          iconColor: "red",
          bgColor: "rgba(255, 0, 0, 0.1)",
        }
      ],

      dashboard_data: [],
      ip_data: [],
    };
  },

  async mounted() {
    this.fetchDashboardData();
    this.fetchIPData();
    this.intervalId = setInterval(() => {
        this.fetchIPData();
      }, 6000);
  },

  methods: {
    async fetchIPData() {
      try {
        const response = await useElcMonitorApi().getPopList(); 
        this.ip_data = response.data;
      } catch (error) {
        console.error("Error fetching Ip data:", error);
      }
    },
    async deleteItem(id) {
      try {
        await useElcMonitorApi().deleteIp(id);  
        this.fetchIPData(); 
      } catch (error) {
        console.error("Error deleting item:", error);
      }
    },
    async fetchDashboardData() {
      try {
        const response = await useElcMonitorApi().getDashboard();  
        this.dashboard_data = response;
      } catch (error) {
        console.error("Error fetching Pop data:", error);
      }
    },
  }
};
</script>

<style scoped>
.card {
  border-radius: 10px;
}

.dark-mode .card {
  background-color: #061f3e;
}

.custom-dropdown {
  position: relative;
  display: inline-block;
}

.dropdown-content {
  display: none;
  position: absolute;
  right: 0;
  background-color: white;
  min-width: 120px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
  border-radius: 4px;
  z-index: 1;
}

.dropdown-content a {
  color: #333;
  padding: 8px 12px;
  text-decoration: none;
  display: block;
  font-size: 14px;
  transition: background-color 0.2s;
}

.dropdown-content a:hover {
  background-color: #f5f5f5;
}

/* Show dropdown on hover */
.custom-dropdown:hover .dropdown-content {
  display: block;
}

/* Dark mode support */
.dark-mode .dropdown-content {
  background-color: #1a2234;
}

.dark-mode .dropdown-content a {
  color: #fff;
}

.dark-mode .dropdown-content a:hover {
  background-color: #2a3441;
}
</style>
